export const RESET = 'AUDIO_UPDATE_RESET';
export const SET_ERROR = 'AUDIO_UPDATE_SET_ERROR';
export const SET_RETRIEVED = 'AUDIO_UPDATE_SET_RETRIEVED';
export const SET_UPDATED = 'AUDIO_UPDATE_SET_UPDATED';
export const SET_VIOLATIONS = 'AUDIO_UPDATE_SET_VIOLATIONS';
export const TOGGLE_LOADING = 'AUDIO_UPDATE_TOGGLE_LOADING';
export const UPDATE_RETRIEVED = 'AUDIO_UPDATE_UPDATE_RETRIEVED';



// WEBPACK FOOTER //
// ./src/store/modules/audio/update/mutation_types.js